import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const UserProfileDropdown = () => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.user.user);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const userLogOut = () => {
    //remove user from local storage
    localStorage.removeItem("token");
    dispatch({
      type: "SET_USER",
      payload: null,
    });
    // navigate to login page
    navigate("/login");
  };

  // Get display name for both regular users and location-based users
  const getDisplayName = () => {
    if (!user) return "User";
    if (user.loginType === "location") {
      return user.locationName || "Location";
    }
    return user.name || user.preferredName || user.email || "User";
  };

  // Get initial letter for avatar
  const getInitial = () => {
    const displayName = getDisplayName();
    if (displayName && displayName.length > 0) {
      return displayName.charAt(0).toUpperCase();
    }
    return "U";
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 rounded-full focus:outline-none"
      >
        <div className="bg-gray-200 h-9 w-9 flex items-center justify-center rounded-full font-medium text-gray-700">
          {getInitial()}
        </div>
        <span className="hidden lg:block text-sm font-medium text-gray-800">
          Hello, {getDisplayName()}
        </span>
        <svg
          className="w-4 h-4 text-gray-600"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {open && (
        <div
          className="absolute right-0 z-10 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="menu-button"
          tabIndex="-1"
        >
          <ul className="py-1" role="none">
            {/* <li>
              <a
                href="#"
                className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                role="menuitem"
              >
                <span className="w-5 h-5 text-gray-500">
                  <i className="fas fa-building" />
                </span>
                Business settings
              </a>
            </li>
            <li>
              <a
                href="#"
                className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                role="menuitem"
              >
                <span className="w-5 h-5 text-gray-500">
                  <i className="fas fa-plug" />
                </span>
                Integrations
              </a>
            </li> */}
            <li>
              <a
                href="#"
                className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                role="menuitem"
                onClick={userLogOut}
              >
                <span className="w-5 h-5 text-gray-500">
                  <i className="fas fa-sign-out-alt" />
                </span>
                Logout
              </a>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default UserProfileDropdown;
